import { matchQuery, type Query, type QueryClient } from '@tanstack/react-query';
import {
  attentionQueryRoot,
  bankQueryRoot,
  categoryQueryRoot,
  occurrenceQueryRoot,
  paymentQueryRoot,
  summaryQueryRoot,
} from '../../../../shared/api/index.js';
import { bankTransactionQueries } from '../queries/bank-transaction-queries.js';

export const refreshAfterCategoryChange = async (queryClient: QueryClient): Promise<void> => {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: bankQueryRoot.all() }),
    queryClient.invalidateQueries({ queryKey: categoryQueryRoot.all() }),
    queryClient.invalidateQueries({ queryKey: summaryQueryRoot.all() }),
  ]);
};

const refreshLinkedData = async (
  queryClient: QueryClient,
  isBankQueryRefetched: (query: Query) => boolean,
): Promise<void> => {
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: bankQueryRoot.all(),
      predicate: isBankQueryRefetched,
    }),
    queryClient.invalidateQueries({ queryKey: occurrenceQueryRoot.all() }),
    queryClient.invalidateQueries({ queryKey: paymentQueryRoot.all() }),
    queryClient.invalidateQueries({ queryKey: summaryQueryRoot.all() }),
    queryClient.invalidateQueries({ queryKey: attentionQueryRoot.all(), refetchType: 'all' }),
  ]);
};

export const refreshAfterLink = async (
  queryClient: QueryClient,
  operationId: string,
): Promise<void> => {
  const linkOptionsKey = bankTransactionQueries.linkOptions(operationId).queryKey;
  const isOtherThanLinkOptions = (query: Query): boolean =>
    !matchQuery({ queryKey: linkOptionsKey }, query);

  await Promise.all([
    queryClient.invalidateQueries({ queryKey: linkOptionsKey, refetchType: 'none' }),
    refreshLinkedData(queryClient, isOtherThanLinkOptions),
  ]);
};

export const refreshAfterFailedLink = async (queryClient: QueryClient): Promise<void> => {
  await refreshLinkedData(queryClient, () => true);
};
